export default "__VITE_ASSET__80339b36__"